// pages/index.js
import { useContext, useEffect, useState } from "react";
import styles from "./TotalsCallsList.module.css";
import HeaderFilter from "../HeaderFilter/HeaderFilter";
import axios from "axios";
import {
  API_BASE_URL,
  fetchDashboardDetails,
  fetchTeamDashboard,
  getAgentCalls,
  getAgentCallsByMonth,
  getAllAgentCalls,
  getUserCallsByMonth,
  sendAgentCallsByMonth,
  sendUserAgentCallsByMonth,
} from "../../Store/apiStore";
import { useDashboardStore } from "../../Store/agentZustandStore";
import Loader from "../Loader/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import { RefreshContext } from "../PreventPullToRefresh/PreventPullToRefresh";
import { red } from "@mui/material/colors";
import PopUp from "../Popup/Popup";
import { DateTime } from "luxon";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { askNotificationPermissionOnce } from "../../utils/nativePermissions";
const options = [
  { id: 1, label: "All", imageUrl: "svg/ThreOpbtn.svg" },
  { id: 2, label: "Positive", imageUrl: "svg/greendot.svg" },
  { id: 3, label: "Neutral", imageUrl: "svg/yellodot.svg" },
  { id: 4, label: "Negative", imageUrl: "svg/reddot.svg" },
];
// 
const callsPerPage = 10;
const exportRangeOptions = [
  { value: "last_7_days", label: "Last 7 Days" },
  { value: "this_month", label: "This Month" },
  { value: "last_month", label: "Last Month" },
  { value: "last_6_months", label: "Last 6 Months" },
  { value: "month", label: "Select Month" },
  { value: "custom", label: "Custom Date Range" },
];
// Loading ke waqt table me dikhne wali shimmer rows, aur har column ki chaudai.
const SKELETON_ROWS = [0, 1, 2, 3, 4];
const SKELETON_CELLS = ["70px", "80px", "90px", "60px", "64px"];
export default function Home() {
  const location = useLocation();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const totalAgentView = localStorage.getItem("filterType");
  const sessionAgentId = sessionStorage.getItem("agentId") || "";
  const [refresh, setRefresh] = useState(false);
  const isRefreshing = useContext(RefreshContext);
  const [agentId, setAgentId] = useState(
    totalAgentView === "all" ? "all" : sessionAgentId || ""
  );
  const [data, setData] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: "",
    endDate: "",
  });
  const [selectedSentiment, setSelectedSentiment] = useState(
    sessionStorage.getItem("selectedfilterOption") || "All"
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token") || "";
  // ── Where the Agent filter's list comes from ─────────────────────────────
  // The agent list lives in the dashboard store, but ONLY the Dashboard page
  // ever populates it. Reaching this screen any other way — new agent →
  // fast-agent-detail → Calls,ccccc a nudge deep-link, or a hard refresh — leaves it
  // empty and the Agent filter blank. So: subscribe to the store (so it fills in
  // live instead of being read once), fall back to the persisted sessionStorage
  // copy, and finally to a list we fetch ourselves (see the effect below).
  const storeAgents = useDashboardStore((s) => s.agents);
  const [fallbackAgents, setFallbackAgents] = useState([]);
  const [agentsLoading, setAgentsLoading] = useState(false);
  const fetchAgents = JSON.parse(
    sessionStorage.getItem("dashboard-session-storage")
  );
  const sessionAgents = fetchAgents?.state?.agents || [];
  //console.log(fetchAgents, "fetchAgents")

  // ── Per-agent call-log permission (multi-owner) ──────────────────────────
  // Agents in the dashboard store are tagged with the member's role +
  // permissions for that agent's owner (see fetchTeamDashboard). A team member
  // may view an agent's call logs only if:
  //   - they're an admin for that agent's owner, OR
  //   - that owner granted them viewCallLogs.
  // Owners (not team members) see everything.
  const isTeamMemberTC = !!localStorage.getItem("teamOwnerId");
  const allDashAgents = storeAgents?.length
    ? storeAgents
    : sessionAgents.length
      ? sessionAgents
      : fallbackAgents;
  const canViewAgentLogs = (a) =>
    !isTeamMemberTC ||
    a?.__role === "admin" ||
    a?.__role === "owner" || // your own agent
    !!a?.__permissions?.viewCallLogs;
  // Only the agents whose call logs this member is allowed to see.
  const permittedAgents = allDashAgents.filter(canViewAgentLogs);
  const permittedAgentIds = new Set(
    permittedAgents.map((a) => a.agent_id).filter(Boolean)
  );
  const [filters, setFilters] = useState({ leadType: [], channel: "" });
  const userId = localStorage.getItem("userId") || sessionStorage.getItem("userId");
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [loadedMonths, setLoadedMonths] = useState([]);
  const [showExportModal, setShowExportModal] = useState(false);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [exportRange, setExportRange] = useState("last_7_days");
  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(null);
  const [loadMoreError, setLoadMoreError] = useState("");
  const [loadMoreAvailable, setloadMoreAvailable] = useState(false);

  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState("");
  const [popUpType, setPopUpType] = useState("");

  useEffect(() => {
    askNotificationPermissionOnce();
  }, []);

  // Nothing populated the dashboard store this session (we didn't come via the
  // Dashboard), so the Agent filter would render empty — fetch the list here.
  // Kept in LOCAL state on purpose: writing to the dashboard store would flag it
  // as "fetched" and stop the Dashboard from merging in Cal API keys later.
  useEffect(() => {
    if (allDashAgents.length) return;
    let cancelled = false;
    setAgentsLoading(true);
    (async () => {
      try {
        const res = isTeamMemberTC
          ? await fetchTeamDashboard()
          : userId
            ? await fetchDashboardDetails(userId, token)
            : null;
        if (!cancelled && res?.agents?.length) setFallbackAgents(res.agents);
      } catch (err) {
        console.error("Agent filter: failed to load agents", err);
      } finally {
        if (!cancelled) setAgentsLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Get all months between two dates (inclusive)
  const getMonthsBetween = (startDate, endDate) => {
    const months = [];
    const start = new Date(startDate);
    const end = new Date(endDate);
    let current = new Date(start.getFullYear(), start.getMonth(), 1);
    while (current <= end) {
      months.push({ month: current.getMonth() + 1, year: current.getFullYear() });
      current.setMonth(current.getMonth() + 1);
    }
    return months;
  };

  // Load calls for all required months
  const loadCallsForRange = async (startDate, endDate) => {
    const months = getMonthsBetween(startDate, endDate);
    setLoading(true);
    try {
      const allCalls = [];
      for (const { month, year } of months) {
        const key = `${month}-${year}`;
        if (loadedMonths.includes(key)) continue; // skip already loaded
        let res;
        if (agentId === "all") {
          res = await getUserCallsByMonth(userId, month, year);
        } else {
          res = await getAgentCallsByMonth(agentId, month, year);
        }
        if (res?.calls) allCalls.push(...res.calls);
        setLoadedMonths((prev) => [...prev, key]);
      }
      if (allCalls.length > 0) {
        setData((prev) => {
          const existingIds = new Set(prev.map(c => c.call_id));
          const newCalls = allCalls.filter(c => !existingIds.has(c.call_id));
          return [...prev, ...newCalls];
        });
      }
    } catch (err) {
      console.error("Error loading calls for range:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedYear = sessionStorage.getItem("selectedYear");
    const storedMonth = sessionStorage.getItem("selectedMonth");

    if (storedYear && storedMonth) {
      setSelectedYear(storedYear);
      setSelectedMonth(storedMonth);
    } else {
      setSelectedYear("");
      setSelectedMonth("");
    }
    // Load current month + previous month by default
    setLoadedMonths([]);
    setData([]);
    const now = new Date();
    const prevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    loadCallsForRange(prevMonth, now);
  }, [agentId, refresh]);

  // Auto-load months when date range changes
  useEffect(() => {
    if (selectedDateRange.startDate && selectedDateRange.endDate) {
      loadCallsForRange(new Date(selectedDateRange.startDate), new Date(selectedDateRange.endDate));
    }
  }, [selectedDateRange.startDate, selectedDateRange.endDate]);

  const fetchCalls = async (month, year, append = false) => {
    try {
      setLoading(true);
      let res;
      if (agentId === "all") {
        res = await getUserCallsByMonth(userId, month, year);
      } else {
        res = await getAgentCallsByMonth(agentId, month, year);
      }

      if (res.status == false) {
        setLoadMoreError(res.error || "No more calls to load");
      }
      const newCalls = res?.calls || [];
      setData((prev) => (append ? [...prev, ...newCalls] : newCalls));

      // Month store

      setLoadedMonths((prev) => [...prev, `${month}-${year}`]);

      setloadMoreAvailable(res.hasRecordingsLastMonths);
    } catch (err) {
      console.error("Error fetching calls:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCalls(currentMonth, currentYear);
  }, [agentId, refresh]);

  // Load previous month's data (manual "Load More")
  const loadMore = () => {
    // Find oldest loaded month and go one back
    const sorted = [...loadedMonths].map(k => {
      const [m, y] = k.split("-").map(Number);
      return { month: m, year: y, ts: new Date(y, m - 1, 1).getTime() };
    }).sort((a, b) => a.ts - b.ts);

    let prevMonth, prevYear;
    if (sorted.length > 0) {
      prevMonth = sorted[0].month - 1;
      prevYear = sorted[0].year;
      if (prevMonth < 1) { prevMonth = 12; prevYear -= 1; }
    } else {
      prevMonth = currentMonth - 1;
      prevYear = currentYear;
      if (prevMonth < 1) { prevMonth = 12; prevYear -= 1; }
    }

    const key = `${prevMonth}-${prevYear}`;
    if (!loadedMonths.includes(key)) {
      const start = new Date(prevYear, prevMonth - 1, 1);
      const end = new Date(prevYear, prevMonth, 0); // last day of that month
      loadCallsForRange(start, end);
    }
  };

  const convertMsToMinSec = (durationMs) => {
    const minutes = Math.floor(durationMs / 60000);
    const seconds = Math.floor((durationMs % 60000) / 1000);
    return `${minutes} min ${seconds} sec`;
  };
  const getTimeFromTimestamp = (timestamp, timezone) => {
    if (!timestamp) return "-";
    return DateTime.fromMillis(timestamp)
      .setZone(timezone || "UTC")
      .toFormat("hh:mm a");
  };
  const getDateFromTimestamp = (timestamp, timezone) => {
    if (!timestamp) return "-";
    return DateTime.fromMillis(timestamp)
      .setZone(timezone || "UTC")
      .toFormat("dd LLL yyyy");
  };
  const filteredData = data?.filter((call) => {
    // If selected sentiment is "Chat", only include api_chat type
    const chatTypeMatch =
      selectedSentiment === "Chat" ? call?.call_type === "api_chat" : true;
    const callTypeMatch =
      selectedSentiment === "Call" ? call?.call_type === "phone_call" || call?.call_type === "web_call" || call?.call_type === "direct_transfer" || call?.call_type === "failed_transfer" : true;
    const transferMatch =
      selectedSentiment === "Transferred" ? call?.call_type === "direct_transfer" :
        selectedSentiment === "Missed Transfer" ? call?.call_type === "failed_transfer" : true;
    const sentimentMatch =
      selectedSentiment === "All" ||
      selectedSentiment === "Chat" || selectedSentiment === "Call" ||
      selectedSentiment === "Transferred" || selectedSentiment === "Missed Transfer" ||
      call?.user_sentiment === selectedSentiment ||
      call?.call_analysis?.user_sentiment === selectedSentiment;
    // console.log(sentimentMatch, "sentimentMatch")
    const inDateRange = (() => {
      if (!selectedDateRange.startDate || !selectedDateRange.endDate)
        return true;

      const startDate = new Date(selectedDateRange.startDate);
      startDate.setHours(0, 0, 0, 0);

      const endDate = new Date(selectedDateRange.endDate);
      endDate.setHours(23, 59, 59, 999);

      return (
        call.end_timestamp >= startDate.getTime() &&
        call.end_timestamp <= endDate.getTime()
      );
    })();
    const leadTypeMatch =
      !filters ||
      !Array.isArray(filters?.leadType) ||
      filters?.leadType.length === 0 ||
      filters?.leadType.includes(
        call.custom_analysis_data?.lead_type ||
        call?.call_analysis?.custom_analysis_data?.lead_type
      );
    const channelMatch =
      filters?.channel === "" || call?.call_type === filters?.channel;
    // Team members only ever see calls of agents they're permitted to view.
    // This also protects the "All" view (which fetches every owner-agent call)
    // and any direct URL access — no call from an un-permitted agent leaks.
    const agentPermitted = !isTeamMemberTC || permittedAgentIds.has(call.agent_id);
    return sentimentMatch && inDateRange && leadTypeMatch && channelMatch && chatTypeMatch && callTypeMatch && transferMatch && agentPermitted;
  });

  // Pagination
  const totalPages = Math.ceil(filteredData?.length / callsPerPage);
  const indexOfLastCall = currentPage * callsPerPage;
  const indexOfFirstCall = indexOfLastCall - callsPerPage;
  const currentCalls = filteredData.slice(indexOfFirstCall, indexOfLastCall);
  // Keep the footer compact even when a call list has many pages. This mirrors
  // the page pattern: first page, current page, an ellipsis where needed, and
  // the final page.
  const paginationItems = (() => {
    if (totalPages <= 1) return [1];

    const pages = [...new Set([1, currentPage, totalPages])].sort(
      (first, second) => first - second
    );

    return pages.reduce((items, page, index) => {
      if (index > 0 && page - pages[index - 1] > 1) {
        items.push(`ellipsis-${pages[index - 1]}-${page}`);
      }
      items.push(page);
      return items;
    }, []);
  })();
  // Handle page change
  const handlePageChange = (pageNum) => {
    if (pageNum < 1 || pageNum > totalPages) return;
    setCurrentPage(pageNum);
  };
  const navigate = useNavigate();

  const formattedDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };
  const getSentimentClass = (sentiment) => {
    switch (sentiment?.toLowerCase()) {
      case "positive":
        return styles.fromGreen;
      case "negative":
        return styles.fromRed;
      case "neutral":
        return styles.fromYellow;
      default:
        return "";
    }
  };
  const handleExportClick = () => {
    setShowExportModal(true);
  };

  const handleYearSelect = (year) => {
    setSelectedYear(year);
    setSelectedMonth("");
    sessionStorage.removeItem("selectedYear");
    sessionStorage.removeItem("selectedMonth");
  };

  // Custom export can't start before the agent existed. For "all" agents use
  // the oldest permitted agent.
  const exportMinDate = (() => {
    const list =
      agentId === "all"
        ? permittedAgents
        : permittedAgents.filter((a) => a.agent_id === agentId);
    const times = list
      .filter((a) => a?.createdAt)
      .map((a) => new Date(a.createdAt).getTime())
      .filter(Number.isFinite);
    return times.length ? new Date(Math.min(...times)) : null;
  })();

  const isExportValid =
    exportRange === "month"
      ? !!selectedYear && !!selectedMonth
      : exportRange === "custom"
        ? !!customStartDate && !!customEndDate
        : true;

  const handleExportSubmit = async () => {
    if (!isExportValid) return;
    // Whole calendar months go as month/year; everything else as a date range.
    let month = "";
    let year = "";
    let range = null;
    const now = DateTime.now();
    // Full local-day bounds as ISO instants (with offset) so the backend
    // filters on the user's own days, not UTC ones.
    const toRange = (start, end) => ({
      startDate: start.startOf("day").toISO(),
      endDate: end.endOf("day").toISO(),
    });
    if (exportRange === "month") {
      month = selectedMonth;
      year = selectedYear;
    } else if (exportRange === "this_month") {
      // 1st → today is the whole current month so far.
      month = now.month;
      year = now.year;
    } else if (exportRange === "last_month") {
      const lastMonth = now.minus({ months: 1 });
      month = lastMonth.month;
      year = lastMonth.year;
    } else if (exportRange === "last_7_days") {
      range = toRange(now.minus({ days: 7 }), now);
    } else if (exportRange === "last_6_months") {
      range = toRange(now.minus({ months: 6 }), now);
    } else {
      range = toRange(
        DateTime.fromJSDate(customStartDate),
        DateTime.fromJSDate(customEndDate)
      );
    }
    setIsLoadingSubmit(true);

    try {
      let response;
      if (agentId === "all") {
        response = await sendUserAgentCallsByMonth(userId, month, year, range);
      } else {
        response = await sendAgentCallsByMonth(agentId, month, year, range);
      }
      if (response.status === false) {
        // e.g. no calls in the period — keep the modal open so another period
        // can be picked.
        setPopUpMessage(response.error);
        setPopUpType("failed");
        setShowPopUp(true);
        return;
      } else {
        // Same export already running / just sent → the backend says so
        // instead of emailing it again.
        setPopUpMessage(
          response.duplicate && response.message
            ? response.message
            : "Your call details are being prepared and will be sent to your email. You can expect to receive them within the next 10 to 15 minutes."
        );
        setPopUpType("success");
      }
      setShowPopUp(true);
      setShowExportModal(false);
      sessionStorage.removeItem("selectedYear");
      sessionStorage.removeItem("selectedMonth");
      setSelectedYear("");
      setSelectedMonth("");
      setCustomStartDate(null);
      setCustomEndDate(null);
    } catch (error) {
      setPopUpMessage("Unable to start the export. Please try again.");
      setPopUpType("failed");
      setShowPopUp(true);
      console.error("Error during email sending:", error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const filterParam = queryParams.get("filter");

    if (filterParam === "chatHistory") {
      setSelectedSentiment("Chat");
      setCurrentPage(1);
    }
    else if (filterParam === "callHistory") {
      setSelectedSentiment("Call");
      setCurrentPage(1);
    }
  }, [location.search]);
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        {/* Agents gate the team-member call filter (permittedAgentIds), so the
            result count isn't trustworthy until they've loaded — keep the
            date-preset auto-fallback waiting until both are done. */}
        <HeaderFilter
          options={options}
          loading={loading || agentsLoading}
          resultCount={filteredData.length}
          selectedSentiment={selectedSentiment}
          onFilter={(label) => {
            setSelectedSentiment(label);
            setCurrentPage(1);
          }}
          isAgents={permittedAgents}
          onRangeChange={(range) => {
            setSelectedDateRange(range);
            setCurrentPage(1);
          }}
          selectedAgentId={agentId}
          onAgentChange={(newAgentId) => {
            setRefresh((prev) => !prev);
            setCurrentMonth(new Date().getMonth() + 1);
            setCurrentYear(new Date().getFullYear());
            setLoadedMonths([]);
            setAgentId(newAgentId);
            sessionStorage.setItem("agentId", newAgentId);
            localStorage.setItem("filterType", "agent");
            setLoadMoreError("");
            setCurrentPage(1);
          }}
          isCallSummary={data}
          filters={filters}
          onFilterChange={(newFilters) => {
            setFilters(newFilters);
            setCurrentPage(1);
          }}
        // onChatFilter={handleChatFilter} // ✅ Pass the function here

        />
        <button className={styles.exportButton} onClick={handleExportClick}>
          <svg width="55" height="64" viewBox="0 0 55 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_12643_10252)">
              <path d="M9 14C9 11.2386 11.2386 9 14 9H55V55H14C11.2386 55 9 52.7614 9 50V14Z" fill="#6524EB" />
            </g>
            <path d="M31.2706 37.9907C31.368 38.088 31.4654 38.153 31.5953 38.2179C31.7251 38.2828 31.855 38.2828 31.9848 38.2828C32.1147 38.2828 32.2445 38.2504 32.3744 38.2179C32.5042 38.153 32.6016 38.088 32.699 37.9907L39.8083 30.8813C40.1979 30.4918 40.1979 29.8425 39.8083 29.453C39.4188 29.0634 38.7695 29.0634 38.38 29.453L32.9911 34.8418V20.0063C32.9911 19.4545 32.5367 19 31.9848 19C31.4329 19 30.9785 19.4545 30.9785 20.0063V34.8093L25.5897 29.453C25.2001 29.0634 24.5509 29.0634 24.1613 29.453C23.7718 29.8425 23.7718 30.4918 24.1613 30.8813L31.2706 37.9907Z" fill="white" />
            <path d="M43.9638 36.2695C43.4119 36.2695 42.9575 36.724 42.9575 37.2759C42.9575 40.3598 40.4578 42.8595 37.3739 42.8595H26.6287C23.5448 42.8595 21.0451 40.3598 21.0451 37.2759C21.0451 36.724 20.5907 36.2695 20.0388 36.2695C19.4869 36.2695 19 36.724 19 37.2759C19 41.4636 22.4086 44.9046 26.6287 44.9046H37.3739C41.5616 44.9046 44.9701 41.496 44.9701 37.2759C44.9701 36.724 44.5157 36.2695 43.9638 36.2695Z" fill="white" />
            <defs>
              <filter id="filter0_d_12643_10252" x="0" y="0" width="64" height="64" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_12643_10252" />
                <feOffset />
                <feGaussianBlur stdDeviation="4" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.396078 0 0 0 0 0.141176 0 0 0 0 0.921569 0 0 0 0.5 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12643_10252" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_12643_10252" result="shape" />
              </filter>
            </defs>
          </svg>

        </button>
        {showExportModal && (
          <div className={styles.exportModal}>
            <div className={styles.modalContent}>
              <h3 className={styles.TitleH3}>Export Calls</h3>
              <div className={styles.rangeSelectContainer}>
                <select
                  value={exportRange}
                  onChange={(e) => setExportRange(e.target.value)}
                >
                  {exportRangeOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              {exportRange === "custom" && (
                <div className={styles.selectContainer}>
                  <DatePicker
                    selected={customStartDate}
                    onChange={(date) => {
                      setCustomStartDate(date);
                      if (customEndDate && date && date > customEndDate) {
                        setCustomEndDate(null);
                      }
                    }}
                    selectsStart
                    startDate={customStartDate}
                    endDate={customEndDate}
                    minDate={exportMinDate}
                    maxDate={new Date()}
                    dateFormat="dd MMM yyyy"
                    placeholderText="From"
                    className={styles.dateInput}
                    wrapperClassName={styles.dateInputWrapper}
                  />
                  <DatePicker
                    selected={customEndDate}
                    onChange={(date) => setCustomEndDate(date)}
                    selectsEnd
                    startDate={customStartDate}
                    endDate={customEndDate}
                    minDate={customStartDate || exportMinDate}
                    maxDate={new Date()}
                    dateFormat="dd MMM yyyy"
                    placeholderText="To"
                    className={styles.dateInput}
                    wrapperClassName={styles.dateInputWrapper}
                  />
                </div>
              )}
              {exportRange === "month" && (
              <div className={styles.selectContainer}>
                <select
                  value={selectedYear}
                  onChange={(e) => handleYearSelect(e.target.value)}
                  className={styles.yearSelect}
                >
                  <option value="">Select Year</option>
                  {[2025, 2026].map(
                    (year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    )
                  )}
                </select>

                {selectedYear && (
                  <select
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                    className={styles.monthSelect}
                  >
                    <option value="">Select Month</option>
                    {[
                      "January",
                      "February",
                      "March",
                      "April",
                      "May",
                      "June",
                      "July",
                      "August",
                      "September",
                      "October",
                      "November",
                      "December",
                    ].map((month, index) => (
                      <option key={index} value={index + 1}>
                        {month}
                      </option>
                    ))}
                  </select>
                )}
              </div>
              )}
              <div className={styles.buttonsContainer}>
                <button
                  className={styles.cancelButton}
                  onClick={() => setShowExportModal(false)}
                >
                  Cancel
                </button>
                <button
                  className={styles.submitButton}
                  onClick={handleExportSubmit}
                  disabled={isLoadingSubmit || !isExportValid}
                >
                  {isLoadingSubmit ? <Loader size={16} /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Table */}
        <div className={styles.tableContainer}>
          <table className={styles.table}>
            <thead className={styles.thead}>
              <tr>
                <th>Date & Time</th>
                <th>Duration</th>
                <th>From</th>
                <th>Lead Type</th>
                <th>Sentiment</th>
              </tr>
            </thead>
            <tbody className={styles.tbody}>
              {loading ? (
                // Loader ki jagah asli rows jaisa shimmer — table ka dhaancha
                // bana rehta hai, data aane par uchhalta nahi.
                SKELETON_ROWS.map((row) => (
                  <tr key={row} aria-hidden="true">
                    {SKELETON_CELLS.map((width, cell) => (
                      <td key={cell}>
                        <span className={styles.shimmerCell} style={{ width }} />
                        {/* Pehle column me do line hoti hain: waqt + tareekh. */}
                        {cell === 0 && (
                          <span className={`${styles.shimmerCell} ${styles.shimmerCellSub}`} />
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              ) : currentCalls.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    No data found
                  </td>
                </tr>
              ) : (
                currentCalls.map((call, i) => (
                  <tr
                    key={i}
                    className={styles.clickableRow}
                    style={{ cursor: (call.call_type === "direct_transfer" || call.call_type === "failed_transfer") ? "default" : "pointer" }}
                    onClick={() => {
                      // Transfer logs have no call detail page
                      if (call.call_type === "direct_transfer" || call.call_type === "failed_transfer") return;
                      if (!call.call_id) {
                        console.warn("Missing call_id for this call:", call);
                        return;
                      }
                      navigate(`/call-details/${call.call_id}`, {
                        state: {
                          agentId: call.agent_id,
                          start_timestamp: call.start_timestamp,
                        },
                      });
                    }}
                  >
                    <td>
                      {" "}
                      <div className={styles.callDateTime}>
                        <div className={styles.callTime}>
                          {call?.start_timestamp
                            ? getTimeFromTimestamp(call.start_timestamp, call.timezone)
                            : "-"}
                        </div>

                        <div className={styles.callDate}>
                          {call?.start_timestamp
                            ? getDateFromTimestamp(call.start_timestamp, call.timezone)
                            : "-"}
                        </div>
                      </div>
                    </td>
                    <td>
                      {call.call_type == "api_chat" ? call?.duration_ms : call?.duration_ms
                        ? convertMsToMinSec(call.duration_ms)
                        : "-"}
                    </td>
                    <td>
                      {" "}
                      <p
                        className={`${styles.fromNumber} ${getSentimentClass(
                          call.user_sentiment ||
                          call?.call_analysis?.user_sentiment
                        )}`}
                      >
                        {call?.call_type === "phone_call"
                          ? // Outbound me from_number business ka apna number hai — lead to_number pe hai.
                            (String(call?.direction || "").toLowerCase() === "outbound" ||
                            call?.retell_llm_dynamic_variables?.lead_phone
                              ? call?.to_number || call?.retell_llm_dynamic_variables?.lead_phone || call?.from_number
                              : call?.from_number)
                          : call?.call_type === "api_chat" ? "chat"
                            : call?.call_type === "web_call" ? "Web Call"
                              : (call?.call_type === "direct_transfer" || call?.call_type === "failed_transfer")
                                ? (call?.from_number || "Transfer")
                                : call?.call_type}{" "}
                      </p>
                      {(call?.call_type === "direct_transfer" || call?.call_type === "failed_transfer") && (() => {
                        const isVip = call.contact_tier === "vip" || call.contact_tier === "whitelist";
                        const label = isVip ? "VIP" : "Contact";
                        const isSuccess = call.call_type === "direct_transfer";
                        const name = call.contact_name || call.custom_analysis_data?.name || "";
                        return (
                          <span style={{
                            fontSize: 10, padding: "2px 8px", borderRadius: 4, fontWeight: 600,
                            marginTop: 2, display: "inline-block",
                            background: isSuccess ? "#E8F5E9" : "#FFEBEE",
                            color: isSuccess ? "#2E7D32" : "#C62828",
                          }}>
                            {label} - {isSuccess ? "Transferred" : "Missed Transfer"}
                          </span>
                        );
                      })()}
                      {(call?.message_taken || call?.custom_analysis_data?.message_taken) && (
                        <span style={{
                          fontSize: 10,
                          padding: "1px 6px",
                          borderRadius: 4,
                          fontWeight: 600,
                          marginTop: 2,
                          display: "inline-block",
                          background: "#E8F5E9",
                          color: "#2E7D32",
                        }}>
                          Message Taken
                        </span>
                      )}
                    </td>

                    <td>
                      {(() => {
                        const leadType =
                          call?.custom_analysis_data?.lead_type ||
                          call?.call_analysis?.custom_analysis_data
                            ?.lead_type ||
                          "-";
                        return (
                          leadType.charAt(0).toUpperCase() + leadType.slice(1)
                        );
                      })()}
                    </td>

                    <td>
                      {(() => {
                        const sentiment =
                          call?.user_sentiment ||
                          call?.call_analysis?.user_sentiment ||
                          "-";
                        return (
                          sentiment.charAt(0).toUpperCase() + sentiment.slice(1)
                        );
                      })()}
                    </td>

                    {/* <td className={styles.CallName}>-</td>
                    <td>
                      <div className={styles.actionIcons}>
                    
                        <svg
                          width="26"
                          height="23"
                          viewBox="0 0 26 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.8254 17.0938L16.9809 14.2493C15.9707 13.2391 14.2427 13.6378 13.8173 14.9671C13.5249 15.8709 12.4881 16.4026 11.5842 16.1899C9.5638 15.6848 6.79901 13.0264 6.29391 10.8996C6.00148 9.99576 6.58634 8.95896 7.51679 8.66653C8.84601 8.26777 9.24478 6.53979 8.23458 5.50299L5.39004 2.65845C4.56592 1.94067 3.36962 1.94067 2.65184 2.65845L0.711169 4.59911C-1.2295 6.61953 0.923848 12.0162 5.68247 16.8014C10.4411 21.5866 15.8377 23.8197 17.8847 21.7727L19.8254 19.832C20.5432 19.0345 20.5432 17.8116 19.8254 17.0938Z"
                            fill="#B5A0F3"
                          />
                          <path
                            d="M22.749 19.2471H21.5527V17.7584H22.749C23.4668 17.7584 24.0517 17.1736 24.0517 16.4558V2.79137C24.0517 2.07359 23.4668 1.48872 22.749 1.48872H14.6673C13.9496 1.48872 13.3647 2.07359 13.3647 2.79137V13.691H11.876V2.79137C11.876 1.24947 13.1254 0 14.6673 0H22.749C24.2909 0 25.5404 1.24947 25.5404 2.79137V16.4558C25.5404 17.9977 24.2909 19.2471 22.749 19.2471Z"
                            fill="#5F33E1"
                          />
                          <path
                            d="M21.9531 4.12109H15.626V5.60982H21.9531V4.12109Z"
                            fill="#5F33E1"
                          />
                          <path
                            d="M21.9531 7.7627H15.626V9.25142H21.9531V7.7627Z"
                            fill="#5F33E1"
                          />
                          <path
                            d="M21.9531 11.4053H15.626V12.894H21.9531V11.4053Z"
                            fill="#5F33E1"
                          />
                        </svg>
                      </div>
                    </td> */}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {filteredData.length > 0 && (
          <>
            <div className={styles.pagination}>
              <button
                type="button"
                className={styles.navigationButton}
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                aria-label="Previous page"
              >
                &#8249;
              </button>

              {paginationItems.map((item) => {
                if (typeof item === "string") {
                  return (
                    <span key={item} className={styles.ellipsis} aria-hidden="true">
                      ...
                    </span>
                  );
                }

                const pageNum = item;
                return (
                  <button
                    type="button"
                    key={pageNum}
                    onClick={() => handlePageChange(pageNum)}
                    className={
                      currentPage === pageNum ? styles.pageButtonActive : ""
                    }
                    aria-label={`Page ${pageNum}`}
                    aria-current={currentPage === pageNum ? "page" : undefined}
                  >
                    {pageNum}
                  </button>
                );
              })}

              <button
                type="button"
                className={styles.navigationButton}
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                aria-label="Next page"
              >
                &#8250;
              </button>
            </div>
            {/* Load More abhi ke liye band — loadMore() waise ka waisa hai, wapas chahiye to bas ye block uncomment karo.
            {currentPage === totalPages && (
              <div style={{ textAlign: "center", padding: "12px 0" }}>
                <button
                  onClick={loadMore}
                  disabled={loading}
                  style={{
                    padding: "8px 24px",
                    background: loading ? "#ddd" : "#6524eb",
                    color: "#fff",
                    border: "none",
                    borderRadius: 20,
                    fontSize: 13,
                    fontWeight: 600,
                    cursor: loading ? "not-allowed" : "pointer",
                  }}
                >
                  {loading ? "Loading..." : "Load More"}
                </button>
              </div>
            )}
            */}
          </>
        )}
      </div>
      {showPopUp && (
        <PopUp
          type={popUpType}
          message={popUpMessage}
          onClose={() => setShowPopUp(false)}
          onConfirm={() => {
            setShowPopUp(false);
          }}
        />
      )}
    </div>
  );
}
